import React from 'react';
import {connect} from 'react-redux';
import {formValueSelector} from 'redux-form';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {Card, Button, Icon, Loader, Table} from 'semantic-ui-react';
import {getColumns} from './vehiclesTableColumns';
import {Link} from 'react-router-dom';
import {reverseShortDate, fullDateShow} from '../../../common/constants/datesFormat';
import moment from 'moment';
import {ExportToExcelButton} from '../../../common/util/exportToExcel/exportToExcelButtons';
import {DISPATCH_ORDER_FORM} from '../../../common/forms';
import VehiclesTable from './vehiclesTable';
import '../dispatchOrdersStyles.scss';

class DispatchOrders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'filtered': [],
      'filteredData': [],
      'table': '',
      'columns': getColumns(),
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.DispatchOrders, scopes.See) &&
      !hasAccessPermission(this.props.permissions, resources.DispatchOrders, scopes.Create) &&
      !hasAccessPermission(this.props.permissions, resources.DispatchOrders, scopes.Edit)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchDispatchOrdersList();
  }

  setFilteredData = (filteredRows) => {
    const filteredData = filteredRows.map((x) => {
      const {original} = x;
      return {
        'Nº Orden': original.orderId,
        'Estado': original.statusDescription,
        'Facturación Anticipada': original.anticipatedInvoice === 'N' ? 'NORMAL' : 'ANTICIPADA',
        'Tipo Facturación': original.typeDescription,
        'Facturar A': original.dealerName,
        'Facturar A (Id)': original.dealerId,
        'Creado por': original.addUser,
        'Creado': moment(original.addDate).format(fullDateShow),
        'Modificado por': original.updateUser,
        'Modificado': moment(original.updateDate).format(fullDateShow),
      };
    });
    this.setState({...this.state, 'filteredData': filteredData, 'filtered': filteredRows});
  }

  renderNewDispatchOrderButton() {
    if (!hasAccessPermission(this.props.permissions, resources.DispatchOrders, scopes.Create)) {
      return null;
    }
    return (
      <Button primary className='download' as={Link} to={paths.DispatchOrdersAdd}>
        <Icon name='add' />
        <span>Nuevo</span>
      </Button>
    );
  }
    
  render() {
    const {columns, filteredData, filtered} = this.state;
    const {dispatchOrdersList, loading} = this.props;
    return (
      <div className='set-sales-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Órdenes de Despacho - Listado de órdenes</h2>
              <div className='title-bar-actions'>
                <div className='flex end'>
                  <ExportToExcelButton
                    data={filteredData}
                    fileName={`DispatchOrdersList_${Date.now()}`}
                    ext='xlsx'
                  />
                  {this.renderNewDispatchOrderButton()}
                </div>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid style={{'overflow': 'auto'}}>
          {loading ?
            <Table>
              <Table.Body>
                <Table.Row className='loader'>
                  <Table.Cell colSpan='100%'>
                    <Loader active inline='centered' />
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table> :
            <VehiclesTable tableColumns={columns} tableData={dispatchOrdersList}
              setFilteredData={this.setFilteredData.bind(this)} filteredData={filtered} />
          }
        </Card>
      </div>
    );
  }
}

const {
  fetchDispatchOrdersList,
  fetchDispatchOrder,
  navigateTo,
} = Actions;
  
const mapDispatchToProps = {
  fetchDispatchOrdersList,
  fetchDispatchOrder,
  navigateTo,
};

const mapStateToProps = (state) => {
  const selector = formValueSelector(DISPATCH_ORDER_FORM.name);
  const formValues = selector(state, 'anticipatedInvoice');
  const dispatchOrdersList = state.dispatchOrders.dispatchOrdersList;
  const dispatchOrdersListFormatted = dispatchOrdersList ? dispatchOrdersList.map((x) => {
    return {
      ...x,
      'anticipatedInvoice': x.anticipatedInvoice === 'N' ? 'NORMAL' : 'ANTICIPADA',
      'addDate': moment(x.addDate).format(reverseShortDate),
      'updateDate': moment(x.updateDate).format(reverseShortDate),
    };
  }) : [];
  return {
    'permissions': state.session.permissions,
    'dispatchOrdersList': dispatchOrdersListFormatted,
    'loading': state.dispatchOrders.loading,
    formValues,
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(DispatchOrders);
